import type { PageProps } from 'gatsby';
import React from 'react';

import SetupMfaForm from '@views/Authentication/Mfa/SetupMfaForm';

export default function SetupMfaPage({ params }: PageProps) {
  return <SetupMfaForm {...params} />;
}
